/**
 * Cross-module flag for the account-deletion flow.
 *
 * ProfileContext's snapshot listener treats a missing profile doc as a brand
 * new user and re-creates it (firing a sign_up analytics event). During
 * account deletion the profile doc is deliberately removed while that
 * listener is still mounted, so without this flag every deletion resurrected
 * an orphaned profile doc. DangerZoneSection sets the flag for the duration
 * of the deletion and clears it in a finally — including on failure, so an
 * aborted deletion (or a different account signing in later in the same
 * session) gets normal bootstrap behaviour back.
 */
let deletionInProgress = false;

export function markAccountDeletionInProgress(): void {
  deletionInProgress = true;
}

export function clearAccountDeletionInProgress(): void {
  deletionInProgress = false;
}

export function isAccountDeletionInProgress(): boolean {
  return deletionInProgress;
}
